/**
 * @generated SignedSource<<1c87672122ebb33d688bb320705b59d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClientAccountGroupAccountChangesInput = {
  accountGroupId: any;
  accounts: ReadonlyArray<AccountInput>;
  clientId: any;
};
export type AccountInput = {
  financialAccountId: number;
  id: any;
};
export type AccountGroupAccordion_AddAccountsToClientAccountGroupMutation$variables = {
  input: ClientAccountGroupAccountChangesInput;
};
export type AccountGroupAccordion_AddAccountsToClientAccountGroupMutation$data = {
  readonly AddAccountsToClientAccountGroup: {
    readonly accountGroup: {
      readonly accounts: ReadonlyArray<{
        readonly financialAccountId: number;
        readonly id: any;
      }>;
      readonly id: string;
      readonly name: string;
    } | null;
  };
};
export type AccountGroupAccordion_AddAccountsToClientAccountGroupMutation = {
  response: AccountGroupAccordion_AddAccountsToClientAccountGroupMutation$data;
  variables: AccountGroupAccordion_AddAccountsToClientAccountGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ClientUserPayload",
    "kind": "LinkedField",
    "name": "AddAccountsToClientAccountGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountGroup",
        "kind": "LinkedField",
        "name": "accountGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "financialAccountId",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountGroupAccordion_AddAccountsToClientAccountGroupMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountGroupAccordion_AddAccountsToClientAccountGroupMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3fdb7f0806346ce6f01f4103e36becb1",
    "id": null,
    "metadata": {},
    "name": "AccountGroupAccordion_AddAccountsToClientAccountGroupMutation",
    "operationKind": "mutation",
    "text": "mutation AccountGroupAccordion_AddAccountsToClientAccountGroupMutation(\n  $input: ClientAccountGroupAccountChangesInput!\n) {\n  AddAccountsToClientAccountGroup(input: $input) {\n    accountGroup {\n      accounts {\n        financialAccountId\n        id\n      }\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a71b8e79383a4bda3828a69dcb8267a3";

export default node;
